// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2hv3f","left":"StickyBox_left__37Ot-","right":"StickyBox_right__1s0Pn"};